import BranchFilesHOC from './BranchFilesHOC'
export default BranchFilesHOC


// WEBPACK FOOTER //
// ./src/modules/BranchFilesHOC/index.js